import { AssetLocation } from '/@/modules/asset/enums/AssetLocation';

export class AssetLocationMeta {
  /**
   * @var {string}
   */
  location;

  /**
   * @var {string}
   */
  locationDescription;

  constructor(model = {}) {
    this.location = model.location;
    this.locationDescription = model.locationDescription;
  }

  /**
   * @returns {boolean}
   */
  get isOtherLocation() {
    return this.location === AssetLocation.OTHER.key;
  }
}
